var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-page container"},[_c('menu-title',{attrs:{"title":"Settings"},on:{"onCloseRequested":_vm.onCloseRequested}}),_c('game-settings',{attrs:{"game":_vm.game}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }